import get from 'lodash-es/get.js';

function initMask() {
	window.Loading.Inputmask = new Promise((resolve) => {
		import(/* webpackChunkName: "Inputmask" */ 'inputmask')
			.then((res,) => {
				const Inputmask =  get(res, 'default');
				if (!Inputmask) throw new Error('Inputmask not found');
				Inputmask().mask(document.querySelectorAll('input[data-inputmask]'));
				window.Block.Inputmask = Inputmask;
				resolve();
			}).catch((err) => {
			throw new Error(err);
		});
	});
}

document.addEventListener('DOMContentLoaded', initMask);


